export const REGISTER = "REGISTER"
export const LOGIN = "LOGIN"
export const LOGOUT = "LOGOUT"
export const SAVE_CATALOG = "SAVE_CATALOG"
export const ADD_TO_CART = "ADD_TO_CART"
export const CONFIRM = "CONFIRM"
export const VIEW_ABSTRACT = "VIEW_ABSTRACT"
